// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-shared-components-Header-Header-module__header {
  padding: var(--space-xs) var(--space-xs) var(--space-xs) var(--space-m);
  align-items: center;
  justify-content: space-between;
  border-bottom: var(--control-border-width) solid var(--color-bg-border);
}
.src-shared-components-Header-Header-module__header .src-shared-components-Header-Header-module__breadCrumbs {
  cursor: pointer;
}
.src-shared-components-Header-Header-module__header .src-shared-components-Header-Header-module__breadCrumbs .BreadcrumbsItem-SelectButton .icons--Icon_size_xs {
  --icon-size: 16px;
}
.src-shared-components-Header-Header-module__header .src-shared-components-Header-Header-module__breadCrumbs .BreadcrumbsItem-Link {
  display: flex;
  align-items: center;
}
.src-shared-components-Header-Header-module__header .src-shared-components-Header-Header-module__info {
  column-gap: var(--space-s);
}
.src-shared-components-Header-Header-module__header .src-shared-components-Header-Header-module__actions {
  column-gap: var(--space-m);
}
.src-shared-components-Header-Header-module__header .src-shared-components-Header-Header-module__user {
  cursor: pointer;
}
.src-shared-components-Header-Header-module__header .src-shared-components-Header-Header-module__modal {
  width: 0%;
}

.src-shared-components-Header-Header-module__popover {
  background: var(--color-bg-default);
  border: var(--control-border-width) solid var(--color-bg-border);
  border-radius: var(--space-2xs);
  padding: var(--space-xs);
  flex-direction: column;
}

.Modal-Window {
  min-height: calc(2 * var(--space-5xl)) !important;
  overflow-y: hidden;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/Header/Header.module.scss"],"names":[],"mappings":"AAAA;EACE,uEAAA;EACA,mBAAA;EACA,8BAAA;EACA,uEAAA;AACF;AACE;EACE,eAAA;AACJ;AAAI;EACE,iBAAA;AAEN;AAAI;EACE,aAAA;EACA,mBAAA;AAEN;AAEE;EACE,0BAAA;AAAJ;AAGE;EACE,0BAAA;AADJ;AAIE;EACE,eAAA;AAFJ;AAKE;EACE,SAAA;AAHJ;;AAOA;EACE,mCAAA;EACA,gEAAA;EACA,+BAAA;EACA,wBAAA;EACA,sBAAA;AAJF;;AAQE;EACE,iDAAA;EACA,kBAAA;AALJ","sourcesContent":[".header {\n  padding: var(--space-xs) var(--space-xs) var(--space-xs) var(--space-m);\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: var(--control-border-width) solid var(--color-bg-border);\n\n  .breadCrumbs {\n    cursor: pointer;\n    :global(.BreadcrumbsItem-SelectButton .icons--Icon_size_xs) {\n      --icon-size: 16px;\n    }\n    :global(.BreadcrumbsItem-Link) {\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  .info {\n    column-gap: var(--space-s);\n  }\n\n  .actions {\n    column-gap: var(--space-m);\n  }\n\n  .user {\n    cursor: pointer;\n  }\n\n  .modal {\n    width: 0%;\n  }\n}\n\n.popover {\n  background: var(--color-bg-default);\n  border: var(--control-border-width) solid var(--color-bg-border);\n  border-radius: var(--space-2xs);\n  padding: var(--space-xs);\n  flex-direction: column;\n}\n\n:global {\n  .Modal-Window {\n    min-height: calc(2 * var(--space-5xl)) !important;\n    overflow-y: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `src-shared-components-Header-Header-module__header`,
	"breadCrumbs": `src-shared-components-Header-Header-module__breadCrumbs`,
	"info": `src-shared-components-Header-Header-module__info`,
	"actions": `src-shared-components-Header-Header-module__actions`,
	"user": `src-shared-components-Header-Header-module__user`,
	"modal": `src-shared-components-Header-Header-module__modal`,
	"popover": `src-shared-components-Header-Header-module__popover`
};
export default ___CSS_LOADER_EXPORT___;
